export enum CompetitionType {
    MEMBERS = 'MEMBERS',
    EXTERNAL = 'EXTERNAL',
    MEMBERS_AND_EXTERNAL = 'MEMBERS_AND_EXTERNAL'
}